import {Component, HostListener, OnInit} from '@angular/core';
import { ApiService } from './api.service';
import { User } from './objects/user';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from './objects/account';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { MkdirDialogComponent } from './components/mkdir-dialog/mkdir-dialog.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { ProfilePasswordResetComponent } from './components/profile-password-reset/profile-password-reset.component';
import { MfaFormComponent } from './components/mfa-form/mfa-form.component';
import { UploaderDialogComponent } from './components/uploader-dialog/uploader-dialog.component';
import { SharedDataService } from './services/shared-data.service';
import { FS3Notification } from './objects/notification';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UploadService } from './services/uploader.service';
import { clearFocus } from './utils';
import {BackgroundJobsService} from "./services/background-jobs.service";
import {Breakpoints, MediaMatcher} from "@angular/cdk/layout";
import { environment } from '../environments/environment';
import {AppEvent} from "./objects/appEvent";
import {DialogCanvasComponent} from "./components/dialog-canvas/dialog-canvas.component";
import { v4 } from 'uuid';
import {NavigationItem} from "./objects/navigationItem";
import {PlatformLocation} from "@angular/common";
import {labels} from "../locale/labels";

@Component({
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ApiService]
})

export class AppComponent implements OnInit, OnDestroy {
  environment = environment;
  // App theme. Themes setup in material2-app-theme.scss + list for preview in parseUtils => themesList
  public get brandingTheme(): string {
    // return this._brandingTheme || 'lightgrey-lightblue-red-theme';
    //return this._brandingTheme || 'dark-warm-red-theme';
    // return this._brandingTheme || 'red-white-black-theme';
    return this._brandingTheme || environment['brandingTheme'] || 'red-white-black-theme';
  }

  public set brandingTheme(value: string) {
    this._brandingTheme = value;
    window.localStorage.setItem('brandingTheme', this._brandingTheme)
    this.applyThemeForOverlayContainer()
    if (this.user && this.user.id && this.user.customisable_settings) {
      this.user.customisable_settings['default_theme'] = value;
      this.apiService.saveProfileSettings(this.user.customisable_settings).subscribe(
        () => {},
        error => {}
      );
    }
  }
  //
  // public testClick() {
  //   //window.alert(window.name);
  //   window['closeWebView']();
  // }

  public get bottomToolbar(): string {
    return this._bottomToolbar;
  }

  public set bottomToolbar(value: string) {
    this._bottomToolbar = value;
    window.localStorage.setItem('bottomToolbar', this._bottomToolbar)
  }

  public get appError(): string {
    return this._appError;
  }
  public set appError(value: string) {
    // if (this._appError === value || !value) {
    if (this._appError === value) {
      return;
    }
    this._appError = value;
    if (this._appError) {
      const note = new FS3Notification();
      note.type = 'error';
      note.text = this._appError;
      //if (this.state !== 'login') { // don't show popup errors on login form. Error shown inside login form
      if (!['login','sms_login'].includes(this.state)) { // don't show popup errors on login form. Error shown inside login form
        this.sharedDataService.pushNotification(note)
      }
    }
  }

  public appLang: string;
  public static appLang: string;
  public static labels: Object;
  public static account: Account;
  public static user: User = new User();
  public static getLabel(labelKey,lowerUpper = -1,casing:object = null, sprintfArgs:(string|number)[] = null): string {
    let label = AppComponent.labels[AppComponent.appLang][labelKey] ? AppComponent.labels[AppComponent.appLang][labelKey] :
      (AppComponent.labels[environment['lang']][labelKey] ? AppComponent.labels[environment['lang']][labelKey] : labelKey);
    if(sprintfArgs) label = AppComponent.sprintf(label,sprintfArgs);
    return label;
  }
  public static sprintf(str,args): string {
    return str.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
        ;
    });
  }

  public static extractUserName(shippingName:string): string {
    return shippingName.trim().replace(/\s+/g,' ').split(' ')[1] ? shippingName.trim().replace(/\s+/g,' ').split(' ')[1] : shippingName.trim();
  }

  public static convertSecondsToHMS(secs:number): string {
    return Math.floor(secs / 3600).toString().padStart(2, "0") +
      ':'+ (Math.floor(secs / 60) % 60).toString().padStart(2, "0") +
      ':'+ ((secs % 3600) % 60).toString().padStart(2, "0");
  }
  public static convertHMtoSeconds(hm:string): number {
    const parts = hm.split(':');
    return parseInt(parts[0])*3600 + parseInt(parts[1])*60;
  }

  public static get isTrainerLogin(): boolean {
    return AppComponent.user && AppComponent.user.native_group &&
      (AppComponent.user.native_group['status'] === 'owner' || AppComponent.user.native_group['status'] === 'trainer');
  }
  public isTrainerLogin() {
    return this.user && this.user.native_group &&
      (this.user.native_group['status'] === 'owner' || this.user.native_group['status'] === 'trainer');
  }
  public static get isOwnerLogin(): boolean {
    return AppComponent.user && AppComponent.user.native_group &&
      (AppComponent.user.native_group['status'] === 'owner');
  }
  public isOwnerLogin() {
    return this.user && this.user.native_group &&
      (this.user.native_group['status'] === 'owner');
  }
  public showAllTrainers() {
    //let show_all_trainers: boolean = this.user?.payload ? JSON.parse(this.user.payload)['show_all_trainers'] : false;
    let show_all_trainers: boolean = (this.user?.native_group && this.user?.native_group['status'] == 'owner');
    return show_all_trainers;
  }

  public filterValue = '';
  private _appError = ''; //
  private commonDialogConf = {
    width: '22vw',
    height: '20vh',
    autoFocus: false,
    panelClass: 'common-dialog'
  }

  private _state = 'default'; // login,files,error
  public get state(): string {
    return this._state;
  }
  public set state(value: string) {
    if(this._state == value) {
      return;
    }
    let oldState = this._state;
    this._state = value;
    let appEvent = new AppEvent(AppEvent.APP_STATE_CHANGE, {oldState: oldState, newState: this._state});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public isActiveRequest = false; //
  public passwordChangeAfter2FA = false;
  public folderOwner = false;
  public dirtyArticleEdit = false;
  public urlAfterRedirects = '';
  public splitedPath: Array<any> = []; //deprecated
  public debugMode = false;
  public navigationPath: Array<NavigationItem> = [];
  public folderExist = false;
  public loginFormComponent: LoginFormComponent; // set on LoginFormComponent init
  public mfaFormComponent: MfaFormComponent; // set on MfaFormComponent init
  public ga_qr_code: string;
  public ga_secret: string;
  public profilePasswordResetComponent: ProfilePasswordResetComponent; // set on ProfilePasswordResetComponent init
  public account: Account;
  public user: User = new User();
  public userLoginChecked = false;
  public route: ActivatedRoute;
  public router: Router;
  public isFilterAllowed = false;

  private ctrlKeyDown = false;
  private shiftKeyDown = false;

  public urlPrefix: string;
  public urlParams: object;

  //public listing: ListingModel;

  private _brandingTheme: string;
  private _bottomToolbar = 'Y';
  public userMenuOpened = false;

  private subscriptions = new Subscription();

  public listingComponent: any // TODO: Refactor

  // Set user appereance from localstorage
  private setAppereanceFromLocalStorage(): void {
    const theme: string = window.localStorage.getItem('brandingTheme')
    if (theme) {
      this.brandingTheme = theme;
    }
    this.applyThemeForOverlayContainer()

    const bottomToolbar: string = window.localStorage.getItem('bottomToolbar')
    if (bottomToolbar) {
      this.bottomToolbar = bottomToolbar;
    }
  }

  public isHandset = false;
  layoutMatches = {
    isHandsetDefaultLayout: false,
    isWeb1270Layout: false
  }

  @HostListener('window:resize', ['$event']) public onLayoutChange($event) {
    this.setLayoutMatches();
  }

  constructor(
    public apiService: ApiService,
    route: ActivatedRoute,
    router: Router,
    public dialog: MatDialog,
    private overlayContainer: OverlayContainer,
    private uploadService: UploadService,
    public sharedDataService: SharedDataService,
    private backgroundJobsService: BackgroundJobsService,
    private mediaMatcher: MediaMatcher,
    private platformLocation: PlatformLocation
  ) {
    // const tturl: Observable<string> = route.url.map(segments => segments.join(''));

    //AppComponent.appLang = platformLocation.getBaseHrefFromDOM().replace(/\//g,'');
    let appLangArr = ('/'+platformLocation.getBaseHrefFromDOM()+'/').replace(/\/+/g,'/').split('/');
    AppComponent.appLang = appLangArr[appLangArr.length-2] ? appLangArr[appLangArr.length-2] :
      (environment['lang'] ? environment['lang'] : 'en');
    AppComponent.labels = labels;
    this.appLang = AppComponent.appLang;
    this.appError = '';

    this.router = router;
    this.route = route;

    // route.url.subscribe((url: any) => this.urlChange(url));
    this.setLayoutMatches();
  }

  private setLayoutMatches() {
    const handsetBreakPoints = Breakpoints.Handset.split(', ');
    this.isHandset = false;
    handsetBreakPoints.forEach(media => {
      if (this.mediaMatcher.matchMedia(media).matches) {
        this.isHandset = true;
      }
    })
    if (this.isHandset) {
      this.toggleLayout('isHandsetDefaultLayout')
    } else {
      const match1270 = this.mediaMatcher.matchMedia('(max-width: 1270px)');
      if (match1270.matches) {
        this.toggleLayout('isWeb1270Layout')
      } else {
        this.purgeLayout()
      }
    }
  }

  private toggleLayout(key: string) {
    for ( const x in this.layoutMatches ) {
      if (x === key) {
        this.layoutMatches[x] = true;
      } else {
        this.layoutMatches[x] = false;
      }
    }
  }

  private purgeLayout() {
    for ( const x in this.layoutMatches ) {
      if (this.layoutMatches[x]) {
        this.layoutMatches[x] = false;
      }
    }
  }

  public setUserMenuOpened(isOpen: boolean): void {
    this.userMenuOpened = isOpen;
  }

  public openUploadDialog(): void {
    const dialogRef = this.dialog.open(UploaderDialogComponent, {
      width: '45vw',
      height: '55vh',
      autoFocus: false,
      panelClass: 'uploader-dialog'
    });
    dialogRef
      .afterClosed()
      .subscribe(() => clearFocus());
  }

  // Apply theme for cdk-overlay-container
  private applyThemeForOverlayContainer() {
    const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
    Array.from(overlayContainerClasses)
      .filter((item: string) => item.includes('-theme'))
      .forEach(elClass => {
        overlayContainerClasses.remove(elClass)
      });
    overlayContainerClasses.add(this.brandingTheme);
  }

  public handleGoHome(): void {
    this.router.navigateByUrl(`/`)
    // if(this.state === 'static_article') {
    //   this.router.navigateByUrl(`/`)
    // } else {
    //   this.router.navigateByUrl(`/${this.state}/`)
    // }
  }

  public handleFolderStatus(value: boolean) {
    this.folderExist = value
  }

  urlChange(url: any): void {
    this.urlPrefix = '/';
    this.urlAfterRedirects = url.join('/');
    this.urlAfterRedirects = this.urlPrefix + this.urlAfterRedirects; // always append leading slash
    this.urlAfterRedirects = window.decodeURIComponent(
      this.urlAfterRedirects
    );
    // console.log('!this.urlAfterRedirects',this.urlAfterRedirects,
    //   this.route.queryParams.subscribe(params => {
    //     console.log('params',params)
    //   })
    // );
    this.route.queryParams.subscribe(params => {
      this.urlParams = params;
    })

    if (
      !this.urlAfterRedirects ||
      this.urlAfterRedirects === this.urlPrefix
    ) {
      if (!AppComponent.user.id) {
        if (AppComponent.account) {
          this.router.navigateByUrl(this.urlPrefix + 'sms_login');
          return;
        } else {
          // we have no account data. do nothing, getUserAccount will chose next action
        }
      } else {
        //let baseAction = this.isTrainerLogin() ? 'big_calendar' : 'articles';
        let baseAction = this.isTrainerLogin() ? 'clients' : 'articles';
        this.router.navigateByUrl(this.urlPrefix + baseAction);
        return;
      }
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'messenger' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'messenger/') === 0
    ) {
      this.state = 'messenger';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'trainers_widget' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'trainers_widget/') === 0
    ) {
      this.state = 'trainers_widget';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'sms_login' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'sms_login/') === 0
    ) {
      this.state = 'sms_login';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'calendar' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'calendar/') === 0
    ) {
      this.state = 'big_calendar';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'squash' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'squash/') === 0
    ) {
      this.state = 'squash';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'liqpay_checkout' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'liqpay_checkout/') === 0
    ) {
      this.state = 'liqpay_checkout';
    } else if (
      this.urlAfterRedirects.indexOf(
        this.urlPrefix + 'profile/password-reset/'
      ) === 0
    ) {
      // console.log('password_reset',this.account);
      this.state = 'password_reset';
      // resetPasswordUUID = split;
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'files' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'files/') === 0
    ) {
      this.state = 'files';
      this.checkNavigationExtras();
      if (!AppComponent.user.id) {
        this.appError = 'Your session has expired. Please login to proceed.';
      }
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'clients' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'clients/') === 0
    ) {
      this.state = 'clients';
      if (!AppComponent.user.id) {
      //if (!AppComponent.user.id || !AppComponent.user.snapshots_available) {
        this.appError = 'Your session has expired. Please login to proceed.';
      }
    } else if (
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'r_articles') === 0
    ) {
      //https://poolclublounge.reserwill.com/ua/r_articles/41/ua/53FA3157-1539-49BA-9AD0-7ECC7A643201/abonementy-pool-club-lounge.html
      console.log('new static_article view',url[2].path);
      this.state = 'static_article';
    } else if (
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'articles') === 0
    ) {
      if(!url[1] || url[1]['path'] == 'folders') {
        this.state = 'articles_folders';
      } else if(url[1]['path'] == 'folder' && url[2]['path']) {
        console.log('Navigating to articles folder content. uuid=',url[2]['path']);
        this.state = 'articles';
      } else if(url[2].path.endsWith('.html')) {
        //https://poolclublounge.reserwill.com/ua/articles/53FA3157-1539-49BA-9AD0-7ECC7A643201/abonementy-pool-club-lounge.html
        console.log('old static_article view',url[2].path);
        this.state = 'static_article';
      } else if(url[1]['path'] == 'item' && url[2]['path'] && url[3]['path']) {
        console.log('Navigating to articles item folder_uuid/uuid = ',url[2]['path'],url[3]['path']);
        this.state = (url[4] && url[4]['path']==='edit') ? 'article_item_edit' : 'article_item';
      } else {
        this.state = 'articles_folders';
        //this.router.acti = 'articles_folders';
      }
      if (!AppComponent.user.id && this.state != 'static_article') {
        this.appError = 'Your session has expired. Please login to proceed.';
      } else if(!AppComponent.user.id) {
        this.appError = 'Please login to access all materials.';
      }
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'login' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'login/') === 0
    ) {
      if (!AppComponent.user.id) {
        this.state = 'login';
        this.checkNavigationExtras();
      } else {
        this.router.navigateByUrl(this.urlPrefix + 'files');
        return;
      }
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'reports' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'reports/') === 0
    ) {
      this.state = 'reports';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'workouts' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'workouts/') === 0
    ) {
      this.state = 'workouts';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'recipes' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'recipes/') === 0
    ) {
      this.state = 'recipes';
    } else if (
      this.urlAfterRedirects === this.urlPrefix + 'referrals' ||
      this.urlAfterRedirects.indexOf(this.urlPrefix + 'referrals/') === 0
    ) {
      this.state = 'referrals';
    } else {
      this.state = 'error';
      this.appError = 'Page not found';
    }

    //this.setUrlParts(this.urlAfterRedirects, this.urlPrefix);
  }

  // private setUrlParts(url: string, urlPrefix: string): void {
  //   this.splitedPath = [];
  //   switch (this.state) {
  //     case 'public':
  //       url = url.replace(urlPrefix + 'public', '');
  //       break;
  //     case 'clients':
  //       url = url.replace(urlPrefix + 'clients', '');
  //       break;
  //     case 'articles_folders':
  //       url = url.replace(urlPrefix + 'articles/folders', '');
  //       break;
  //     case 'files':
  //       url = url.replace(urlPrefix + 'files', '');
  //       break;
  //     case 'snapshots':
  //       url = url.replace(urlPrefix + 'snapshots', '');
  //       break;
  //   }
  //   if (url) {
  //     const urlParts = this.unEscapeUrlParts(url);
  //     urlParts.shift();
  //     this.splitedPath = urlParts.map((part, index) => ({ path: part, originalIndex: index }))
  //   }
  // }

  private checkNavigationExtras() {
    if (history.state.isExpired) {
      const notification = new FS3Notification()
      notification.text = 'Your session has expired. Please login to proceed.';
      notification.type = 'error';
      setTimeout(() => {  // let login form to render and then display message
        this.sharedDataService.pushNotification(notification);
      }, 500);
    } else if (history.state.passwordChanged) {
      const notification = new FS3Notification()
      notification.text = 'Your password has been changed successfully.';
      notification.type = 'success';
      setTimeout(() => {  // let login form to render and then display message
        this.sharedDataService.pushNotification(notification);
      }, 500);
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  ngOnInit(): void {
    this.route.url.subscribe((url: any) => this.urlChange(url));
    console.log('Appcomponent init', AppComponent.account, this.account, this.environment, this.state);
    this.pickInitialData();
    this.setAppereanceFromLocalStorage();
  }
  public pickInitialData() {
    if(['trainers_widget'].includes(this.state)) { //skip Account/User data load
      return;
    }
    this.loadAccountUserData();
  }
  public loadAccountUserData() {
    if (AppComponent.account) {
      this.account = AppComponent.account;
      if (!AppComponent.user.id) {
        this.getCurrentUser()
      } else {
        this.user = AppComponent.user;
      }
    } else {
      this.getUserAccount();
    }
  }
  //big calendar has no single calendar to attach a new event to while all of them are shown
  public bigCalendarCombinedView: boolean = false;

  public createBasicEvent() { //big calendar picks this up and opens the basic event form
    let appEvent = new AppEvent(AppEvent.ADD_BASIC_SCHEDULE, {});
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public openNewCourseDialog() {
    let category = {
      sorder: 0,
      group_name: 'Default category',
      group_key: v4().toUpperCase(),
      group_image_src: '',
      articles: [],
    };
    let folderData = {};
    let folderUUID = v4().toUpperCase();
    folderData['uuid'] = folderUUID;
    folderData['name'] = '';
    folderData['picture_src_preview'] = folderData['picture_src_icon'] = folderData['picture_src_ava'] = '';
    folderData['group_id'] = environment['gid'];
    folderData['ctime'] = (new Date()).getTime()/1000;
    folderData['articles_groups'] = [category];
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '50%',
      minHeight: '50%',
      minWidth: this.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this,
        state: 'course-edit',
        payload: {
          folderData: folderData,
          doFolderInsert: true,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.sharedDataService.updateList('/')
        }
      })
  }
  public openMkDirDialog() {
    this.sharedDataService.pushNotification({ text: `This functionality will be available in two weeks time.`, type: 'info' })
    return;
    const dialogRef = this.dialog.open(MkdirDialogComponent, {
      ...this.commonDialogConf,
      height: '21vh',
      data: { urlParts: this.splitedPath.map(el => el.path), state: this.state }
    } as MatDialogConfig);
    dialogRef.afterClosed()
      .subscribe((result: any) => {
        clearFocus();
        if (result) {
          if (result.isSuccess) {
            // this.sharedDataService.updateList(this.uploadService.listingCurrentPath);
            this.sharedDataService.addFilesToListFixed([result.resultFile])
          } else {
            this.showErrorOnFiles(result.error)
          }
        }
      });
  }

  public deleteCourse(): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'course-delete',
        payload: {
          //folderUUID: this.urlAfterRedirects.split('/')[3],
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.apiService
            .deleteFolder(this.user.magic_key, this.urlAfterRedirects.split('/')[3])
            .subscribe(
              data => {
                let notification = new FS3Notification();
                notification.type = 'success';
                notification.text = 'Deleted!';
                this.sharedDataService.pushNotification(notification);
                this.router.navigateByUrl('articles/folders');
              },
              error => {
                const { exception } = error;
                if (exception && exception.error && exception.error.message) {
                  let notification = new FS3Notification();
                  notification.type = 'error';
                  notification.text = exception.error.message;
                  this.sharedDataService.pushNotification(notification);
                }
              }
            )
        }
      })
  }

  public newArticleCategory(): void {
    let appEvent = new AppEvent(AppEvent.NEW_ARTICLE_CATEGORY, null);
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public editArticleItem(): void {
    let folderUUID = this.router.url.split('/')[3]
    let articleUUID = this.router.url.split('/')[4]
    this.router.navigateByUrl('/articles/item/'+folderUUID+'/'+articleUUID+'/edit');
  }
  public saveArticleItem(): void {
    let appEvent = new AppEvent(AppEvent.SAVE_ARTICLE_ITEM, null);
    this.sharedDataService.pushAppEvent(appEvent)
  }

  public handleAllowFilter(value: boolean): void {
    this.isFilterAllowed = value;
  }

  public getPublicFilesByPath(path: string = '/'): void {
    // this.listing.isLoading = true;
    this.isActiveRequest = true;
    this.apiService.getPublicFiles(path, 'public_session_code').subscribe(
      files => this.processPublicFiles(files),
      error => this.showErrorOnFiles(error)
    );
  }

  public formatUrl(url: string): string {
    url = url.replace(/\/+/g, '/');
    const urlParts = url.split('/');
    const escapedParts = [];
    for (let i = 0; i < urlParts.length; i++) {
      const escaped = window.encodeURIComponent(
        window.escape(urlParts[i])
      );
      // var escaped = window.escape(urlParts[i]);
      escapedParts.push(escaped);
    }
    return escapedParts.join('/');
  }

  public unEscapeUrlParts(url: string) {
    const urlParts = url.split('/');
    const unEscapedParts = [];
    for (let i = 0; i < urlParts.length; i++) {
      const unEscaped = window.unescape(urlParts[i]);
      unEscapedParts.push(unEscaped);
    }
    return unEscapedParts;
  }
  public processPublicFiles(files) {
    this.appError = '';
    this.isActiveRequest = false;
    // this.listing.files = files;
    // this.listing.lastFocusedFile = -1;
  }

  private showErrorOnFiles({ exception: { status } }) {
    this.isActiveRequest = false;
    if (status === 401) {
      this.logout()
      // this.logoutInternally();
      return
    }
  }

  public getUserAccount() {
    this.isActiveRequest = true;
    this.apiService.getAccount(this.environment['gid'], this.environment['g_hash']).subscribe(
      account => this.saveCurrentAccount(account),
      error => this.showError(error)
    );
  }

  public saveCurrentAccount(account: Account) {
    this.isActiveRequest = false;
    // this.appError = '';
    this.account = account;
    AppComponent.account = account;
    //window.document.title = account.label + ' Control Panel';
    if (account.customisable_settings && account.customisable_settings['default_theme']) {
      this.brandingTheme = account.customisable_settings['default_theme'];
    }
    //set/replace company specific labels
    const labelsToReplace = ['connect_label','trainer','trainera','training','canceled_training','players_groups','call_to_game','call_to_game_trainer'];
    labelsToReplace.map(labelKey => {
      AppComponent.labels[AppComponent.appLang][labelKey] = account.payload_parsed['labels'][labelKey];
    })

    AppComponent.labels[AppComponent.appLang]['connect_session_restart'] = AppComponent.getLabel('connect_session_restart',-1,null,[
      account.payload_parsed['connect_label']
    ]);
    AppComponent.labels[AppComponent.appLang]['booking_tcs'] = AppComponent.getLabel('booking_tcs',-1,null,[
      account.payload_parsed['tcs_url'],account.payload_parsed['privacy_url']
    ]);
    AppComponent.labels[AppComponent.appLang]['ack_privacy'] = AppComponent.getLabel('ack_privacy',-1,null,[
      account.payload_parsed['privacy_url']
    ]);
    AppComponent.labels[AppComponent.appLang]['ack_tcs'] = AppComponent.getLabel('ack_tcs',-1,null,[
      account.payload_parsed['tcs_url']
    ]);
    AppComponent.labels[AppComponent.appLang]['ack_tcs_required'] = account.payload_parsed['ack_tcs_required'];
    AppComponent.labels[AppComponent.appLang]['connect_game_icon'] = account.payload_parsed['connect_game_icon'];
    this.getCurrentUser(); // update: next App action depends on user.
  }

  public handleLogout(eventData: any = null) {
    if (this.user.id) {
      this.logout(eventData);
    } else {
      this.router.navigateByUrl('/sms_login');
    }
  }

  public logout(eventData: any = null) {
    this.backgroundJobsService.clearJobs();
    window.sessionStorage.clear();
    this.apiService.logout()
      .subscribe(
        () => { },
        error => {
          if (error && error.exception && error.exception.status === 401) {
            return
          }
          this.showError(error)
        }
      );
    this.logoutInternally();
    this.appError = '';
    this.router.navigateByUrl('/sms_login', { state: { isExpired: (eventData && eventData.isExpired) } });
  }

  public logoutInternally() {
    AppComponent.user = new User();
    this.user = AppComponent.user;
  }

  public doLogin(login: string, password: string) {
    this.isActiveRequest = true;
    this.apiService.doLogin(login.trim(), password.trim()).subscribe(
      auth => this.gotAuth(auth),
      error => this.gotLoginError(error)
    );
  }

  public doAccessReset(recover_user: string) {
    this.isActiveRequest = true;
    this.apiService.doAccessReset(recover_user.trim()).subscribe(
      data => {
        this.loginFormComponent.processAccessReset(data);
      },
      error => this.loginFormComponent.showErrorOnAccessReset(error)
    );
  }

  public gotAuth(authData: object) {
    this.backgroundJobsService.clearJobs();
    window.sessionStorage.clear();
    this.isActiveRequest = false;
    this.appError = '';
    if (authData && authData['next_auth'] && authData['setup_mfa']) {
      this.passwordChangeAfter2FA = authData['password_expired']; // todo: refactor after server side fix
      if (authData['mfa_type'] === 'GA') {
        this.apiService.setupMfa('GA').subscribe(
          res => this.gotGaMfa(res),
          error => this.showError(error)
        );
      } else {
        this.state = 'setup_mfa_sms';
      }
      // this.state = (authData['mfa_type']=='GA') ? 'setup_mfa_ga' : 'setup_mfa_sms';
    } else if (authData && authData['next_auth']) {
      this.passwordChangeAfter2FA = authData['password_expired']; // todo: refactor after server side fix
      this.state =
        authData['mfa_type'] === 'GA' ? 'enter_mfa_ga' : 'enter_mfa_sms';
    } else if (authData && authData['password_expired']) {
      this.state = 'password_change';
    } else {
      this.getCurrentUser(true);
    }
    // this.getFiles()
  }

  public gotGaMfa(mfaData: object) {
    this.isActiveRequest = false;
    this.appError = '';
    this.state = 'setup_mfa_ga';
    this.ga_qr_code = mfaData['qr_code'];
    this.ga_secret = mfaData['secret'];
  }

  public getUrlParam(key: string) {
    return (this.urlParams && this.urlParams[key]) ? this.urlParams[key] : null;
  }

  public getCurrentUser(raiseErrorIfUserMissing: boolean = false) {
    const uuid = (this.urlParams && this.urlParams['uuid']) ? this.urlParams['uuid'] : null;
    const magic_hash = (this.urlParams && this.urlParams['magic_hash']) ? this.urlParams['magic_hash'] : null;
//return;
    const subscription = this.apiService.getUser(uuid,magic_hash).subscribe(
      user => this.saveCurrentUser(user),
      error => this.handleMissingUser(error, raiseErrorIfUserMissing)
    );
    this.subscriptions.add(subscription)
  }

  public saveCurrentUser(user: User) {
    console.log('saveCurrentUser',this.state,user)
    this.appError = '';
    this.user = user;
    AppComponent.user = user;
    //window.document.title = AppComponent.account.label + ' Control Panel';
    this.userLoginChecked = true;
    let appEvent = new AppEvent(AppEvent.USER_HAS_BEEN_LOGGED, null);
    this.sharedDataService.pushAppEvent(appEvent)
    if (user.customisable_settings && user.customisable_settings['default_theme']) {
      this.brandingTheme = user.customisable_settings['default_theme'];
    }
    switch (this.state) {
      case 'login':
      case 'default':
      case 'setup_mfa_ga':
      case 'enter_mfa_sms':
      case 'enter_mfa_ga':
      case 'enter_mfa_sms':
        if (this.user.change_password) {
            this.state = 'password_change';
        } else {
          //this.router.navigateByUrl('/files');
          this.isTrainerLogin() ? this.router.navigateByUrl('/clients') : this.router.navigateByUrl('/articles');
        }
        break;
      case 'static_article':
        //all ok. component will handle the rest
        break;
      case 'sms_login':
        if(this.isTrainerLogin()) {
          this.router.navigateByUrl('/clients')
        } else if(user.shipping_name) {
          this.router.navigateByUrl('/squash/userview/'+user.id)
        } else {
          this.router.navigateByUrl('/squash/profile_edit')
        }
        break;
    }
  }

  public handleMissingUser({ errMsg, exception }, raiseErrorIfUserMissing) {
    if (exception.status === 401) { // user not logged. not a real error.
      this.userLoginChecked = true;
      let appEvent = new AppEvent(AppEvent.USER_NOT_LOGGED, null);
      this.sharedDataService.pushAppEvent(appEvent)
      switch (this.state) {
        case 'default':
          this.router.navigateByUrl('/sms_login');
          break;
        case 'clients':
        case 'big_calendar':
        case 'articles_folders':
        case 'articles':
        case 'article_item':
        case 'article_item_edit':
        case 'reports':
        //case 'files':
        //case 'snapshots':
          this.router.navigateByUrl('/login'); //todo: maybe also pass this.appError e.g. when session expired
          break;
        case 'static_article': //all ok. public article
          break;
        case 'login':
        case 'sms_login':
          // we are in right place.
          // but if we landed here after successful login
          // probably cookies disabled. show error message
          if (raiseErrorIfUserMissing) {
            const note = new FS3Notification();
            note.type = 'error';
            note.text = errMsg.toString();
            this.sharedDataService.pushNotification(note)
          }
          break;
        case 'enter_mfa_ga':
        case 'enter_mfa_sms':
          // we are in right place.
          // but if we landed here after successful login
          // probably cookies disabled. show error message
          if (this.passwordChangeAfter2FA) {
            this.passwordChangeAfter2FA = false;
            this.state = 'password_change';
          } else if (raiseErrorIfUserMissing) {
            const note = new FS3Notification();
            note.type = 'error';
            note.text = errMsg.toString();
            this.sharedDataService.pushNotification(note)
          }
          break;
      }
    } else {
      this.showError({ errMsg, exception })
    }
  }

  public onSearchClear() {
    this.filterValue = '';
  }

  private gotLoginError({ errMsg, exception }) {
    this.loginFormComponent.makeNoMatch();
    this.showError({ errMsg, exception });
  }

  private showError({ errMsg, exception }) {
    this.isActiveRequest = false;
    this.appError = errMsg.toString();
    // maybe hide 400 on files state, BUT keep on login state
    // if (exception.status !== 400 && errMsg) {
    //   this.appError = errMsg.toString();
    // }
  }

  public clearNavigation() {
    this.navigationPath = [];
  }
  public setArticlesFoldersNavigation() {
    this.clearNavigation();
    let homeNavigationItem = new NavigationItem();
    homeNavigationItem.route = this.isTrainerLogin() ? '/clients' : '/articles/folders';
    homeNavigationItem.label = 'home';
    this.addNavigationItem(homeNavigationItem)
    let articlesFoldersNavigationItem = new NavigationItem();
    articlesFoldersNavigationItem.route = '/articles/folders';
    articlesFoldersNavigationItem.label = 'Courses';
    this.addNavigationItem(articlesFoldersNavigationItem)
  }
  public addNavigationItem(navigationItem: NavigationItem) {
    //console.log('addNavigationItem',navigationItem);
    this.navigationPath.push(navigationItem);
    if(this.debugMode) {
      console.log('stacktrace')
    }
  }


}
